import { SharedLinesTypes } from "../action/index.model";
import { SharedLine } from "./index.model";

const initialState: SharedLine = {
  loading: true,
  language: "",
  isAssignee: false,
  toastMessage: false,
  noofAttempts: 0,
  msisdn: "",
  longRunningQuery: false,
  error: "",
};

const ShareLinesReducer: any = (
  state: SharedLine = initialState,
  action: any
) => {
  switch (action.type) {
    case SharedLinesTypes.SET_INVITATION_INITIATED_RESPONSE:
      return {
        ...state,
        loading: false,
        language: action?.data.language ? action.data.language : "",
        noofAttempts: state.noofAttempts + 1,
        isAssignee: action?.data.isAssignee
          ? action.data.isAssignee
          : state.isAssignee,
        longRunningQuery: false,
        error: action?.data && action.data?.error ? action.data.error : "",
        toastMessage: action.data?.error ? false : true,
      };
    case SharedLinesTypes.SET_NEW_INVITATION_INITIATED_RESPONSE:
      return {
        ...state,
        loading: false,
        language: "en",
        noofAttempts: state.noofAttempts + 1,
        longRunningQuery: false,
        error: "",
        toastMessage: true,
      };
    case SharedLinesTypes.SET_SHARED_ERROR:
      return {
        ...state,
        error: action.data?.error,
      };
    case SharedLinesTypes.UPDATE_EMAIL_ALREADY_EXISTS:
      return {
        ...state,
        language: "",
        noofAttempts: 0,
        longRunningQuery: false,
        email: "",
        msisdn: "",
        toastMessage: false,
        error: "ALREADY EMAIL EXISTS",
      };
    case SharedLinesTypes.RESET_INVITATION:
      return {
        ...state,
        language: "",
        noofAttempts: 0,
        longRunningQuery: false,
        email: "",
        msisdn: action?.data ? action.data : "",
        isAssignee: false,
        toastMessage: false,
        error: "",
      };
    case SharedLinesTypes.RESET_LANGUAGE_ERROR:
      return {
        ...state,
        language: "",
        error: "",
      };
    case SharedLinesTypes.SET_LONG_RUNNING_QUERY:
      return {
        ...state,
        longRunningQuery: state.language === "",
      };
    case SharedLinesTypes.RESET_TOAST_MESSAGE:
      return {
        ...state,
        toastMessage: false,
      };
    default:
      return state;
  }
};
export default ShareLinesReducer;
